import { Http } from "@/util";

export function getWecomKfInsight(params) {
  return Http.get("/admin/wecom/kf/insight", params);
}

export function buildWecomKfInsight(body) {
  return Http.post("/admin/wecom/kf/insight/build", body);
}

export function getWecomKfSessionPage(params) {
  return Http.get("/admin/wecom/kf/session/page", params);
}

export function getWecomKfSessionDetail(params) {
  return Http.get("/admin/wecom/kf/session/detail", params);
}

export function saveWecomKfReview(body) {
  return Http.post("/admin/wecom/kf/session/review", body);
}

export function getWecomKfServicers(params) {
  return Http.get("/admin/wecom/kf/servicers", params);
}

export function getWecomKfRule(params) {
  return Http.get("/admin/wecom/kf/rule", params);
}

export function saveWecomKfRule(body) {
  return Http.post("/admin/wecom/kf/rule", body);
}

export function testWecomKfRule(body) {
  return Http.post("/admin/wecom/kf/rule/test", body);
}
